import $ from 'jquery';

const key = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'UP': 38,
  'DOWN': 40
}

export default class Dropdown {

  constructor($el) {
    this.root = $el;
    this.button = $el.find(".js-dropdown_btn");
    this.links = this.root.find('.js-dropdown_link');
    this.focusIndex = 0;
    this.numOfLinks = this.links.length;
    this.isOpen = false;

    this.handleEvents();
  }

  handleEvents() {
    this.root.click(() => {
      this.isOpen = !this.isOpen;
      this.toggleList();
    });

    $(document.body).click(() => {
      if (this.isOpen && this.root.hasClass('is-open-add')) {
          this.isOpen = !this.isOpen;
          this.toggleList();
      }
    });

    this.root.focusout(e => {
      if (this.isOpen && 
          !$(e.relatedTarget).hasClass('js-dropdown_link')) {
        this.focusIndex = 0;
        this.isOpen = !this.isOpen;
        this.toggleList();
      }
    });

    // keyboard
    this.root.keydown(e => {
      switch (this.isOpen) {
        case true:
          if (key.DOWN === e.keyCode ||
              key.TAB === e.keyCode) {
            this.focusNextItem();
          }

          if (key.UP === e.keyCode) {
            this.focusPrevItem();
          }

          if (key.ESCAPE === e.keyCode) {
            this.focusIndex = 0;
            this.isOpen = !this.isOpen;
            this.toggleList();
            setTimeout(() => this.focusItem(this.root));
          }
        break;

        case false:
          if (key.DOWN === e.keyCode ||
              key.SPACE === e.keyCode ||
              key.ENTER === e.keyCode) {
            this.isOpen = !this.isOpen;
            this.toggleList();
            this.focusItem(this.links.eq(this.focusIndex));
          }
        break;
      }
    });
  }

  focusNextItem() {
    this.focusItem(this.getNextItem());
  }

  focusPrevItem() {
    this.focusItem(this.getPrevItem());
  }

  focusItem($item) {
    $item.focus();
  }

  getNextItem() {
    this.focusIndex = Math.min(++this.focusIndex, this.numOfLinks-1);
    return this.links.eq(this.focusIndex);
  }

  getPrevItem() {
    this.focusIndex = Math.max(--this.focusIndex, 0);
    return this.links.eq(this.focusIndex);
  }

  toggleList() {

    if (this.shouldPlaceAbove()) {
      this.root.addClass('dcw_dropdown--up');
    } else {
      this.root.removeClass('dcw_dropdown--up');      
    }

    this.root.toggleClass('is-open');
    setTimeout(() => {
      this.root.toggleClass('is-open-add');
    });

    this.button.attr('aria-expanded', this.isOpen);
  }

  shouldPlaceAbove() {
    return window.innerHeight - this.root[0].getBoundingClientRect().bottom < 128;
  }
}


// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown.js